// ============================================================================
// OBT F3 — Aktörün alt zincirinden personnel_id → ad haritası
// ============================================================================
// respondent/öneren adları YALNIZ aktörün kapsamındaki alt zincirden çözülür
// (tüm belediye personeli çekilmez). Ad çözümü zenginleştirmedir; başarısızsa
// akış düşmez ("Bilinmeyen personel" gösterilir).
// ============================================================================

import { useEffect, useState } from 'react';
import { fetchChildChain } from '../reviewApi';

export function useChildNames(personnelId, enabled = true) {
  const [nameById, setNameById] = useState(() => new Map());
  useEffect(() => {
    if (!personnelId || !enabled) {
      setNameById(new Map());
      return undefined;
    }
    let active = true;
    const controller = new AbortController();
    Promise.resolve(fetchChildChain(personnelId, { signal: controller.signal }))
      .then((chain) => {
        if (!active) return;
        const map = new Map();
        for (const node of Array.isArray(chain) ? chain : []) {
          if (node?.personnel_id) map.set(String(node.personnel_id), node.name || '');
        }
        setNameById(map);
      })
      .catch(() => {
        /* zenginleştirme — sessiz geç */
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, [personnelId, enabled]);
  return nameById;
}
